module.exports = __webpack_public_path__ + "img/img16.6e8405ac.jpg";